export enum ShopMaterial {
  RUBBER = "RUBBER",
  PLASTIC = "PLASTIC",
}
